import { api, postRequest } from "../../server/request";
import { handleResponse, handleError } from "../responseUtil";
import { CONFIG_BASE_URL, KAPTUREV2_URL, KAPTUREV2_URL_INV } from "../../config"
import { 
  SET_INVENTORY_LISTING_LOADING,
  GET_TRAFFIC_POLICY_LISTING_LOADING,
  APPLY_TRAFFIC_POLICY_LOADING,
  APPLY_POLICY_ROUTE_LOADING,
  GET_TRAFFIC_POLICY_LOG_LIST_LOADING,
  GET_WAN_PROFILE_LISTING_LOADING,
  GET_POP_IPS_LISTING_LOADING,
  APPLY_FIREWALL_RULE_LOADING,
  APPLY_WAN_PROFILE_LOADING,
  APPLY_HUB_IP_CONFIG_LOADING,
  COPY_QUOTA_CONFIG_LOADING,
  GET_INVENTORY_WAREHOUSE_TABLE_DATA, 
  GET_INVENTORY_WAREHOUSE_VESSEL_LIST , 
  SET_ASSIGN_INVENTORY_TO_VESSEL,
  ASSIGN_INVENTORY_TO_VESSEL , 
  CREATE_AND_ASSIGN_INVENTORY,
  GET_DP_LIST,
  GET_INVENTORY_DEPLOYED_DATA_COUNT,
  SET_INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE,
  INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE,
  INVENTORY_DELETE_SITE,
  INVENTORY_TOP_WIDGETS_REGISTERED_COUNT,
  SET_LOADING,
  INVENTORY_TOP_WIDGETS_WAREHOUSE_COUNT,
  INVENTORY_DOWNLOAD_CONFIG,
  INVENTORY_CHANGE_GROUP,
  GET_CONFIG_PRODUCTS,
  GET_WAN_PROFILE_LIST,
  GET_POP_IPS_LIST,
  APPLY_GOLDEN_CONFIG,
  APPLY_TRAFFIC_POLICY,
  APPLY_POLICY_ROUTE,
  APPLY_FIREWALL_RULE,
  APPLY_WAN_PROFILE,
  APPLY_HUB_IP_CONFIG,
  GET_TRAFFIC_POLICY_LOG_LIST,
  GET_BACKUP_CONFIG_DATA,
  SET_BACKUP_CONFIG_DATA_LOADING,
  GET_DEFAULT_CONFIG_LISTING,
  EDIT_DEFAULT_CONFIG,
  CREATE_DEFAULT_CONFIG,
  DELETE_DEFAULT_CONFIG,
  GET_DEFAULT_PRODUCTS,
  GET_CONFIG_SOFTWARE_VERSIONS,
  GET_CONFIG_STATUS,
  BACKUP_CONFIG_NOW,
  COPY_CONFIG_TO_MANUAL_BACKUP,
  DELETE_MANUAL_BACKUP_CONFIG,
  UPGRADE_DEVICE_TO_LATEST_EOS_VERSION,
  INVENTORY_WAREHOUSE_CHANGE_GROUP,
  REBOOT_DEVICE,
  GET_DEVICE_LIST,
  GET_DP_DEVICES,
  CREATE_INVENTORY_GROUP,
  UPDATE_INVENTORY_GROUP,
  DELETE_INVENTORY_GROUP,
  GET_INVENTORY_GROUP_LIST,
  GET_TRAFFIC_POLICY_LIST,
  GET_INVENTORY_GROUP_LIST_COUNT,
  INVENTORY_GROUP_DEVICES_EOS_UPGRADE,
  INVENTORY_TOP_WIDGET_KAAS_COUNT,
  GET_GROUP_TRANSCATION_CONFIG_STATUS,
  GET_LICENSE_TYPES,
  SET_LICENSE_TYPES,
  GET_SITE_INFO_LIST,
  GET_SITE_INFO_LIST_COUNT,
  GET_DPS_DEFAULT_ACTIVE_CONFIG,
  SET_DEVICE_HISTORY_LOADING,
  GET_DEVICE_HISTORY,
  SET_DEVICE_CONFIG_ACTION_LOGS_LOADING,
  GET_DEVICE_CONFIG_ACTION_LOGS,
  SET_UPGRADE_INVENTORY_LICENSE_LOADING,
  GET_UPGRADE_INVENTORY_LICENSE,
  SET_DEVICE_EOS_HISTORY_EVENTS_LOADING,
  GET_DEVICE_EOS_HISTORY_EVENTS,
  SET_DEVICE_LICENSE_HISTORY_LOADING,
  GET_DEVICE_LICENSE_HISTORY,
  SET_UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION_LOADING,
  UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION,
  SET_T0_AND_OPEN_EDGE_LOADING,
  GET_TRAFFIC_POLICY_LIST_V3,
  GET_TRAFFIC_POLICY_LIST_V4,
  GET_TRAFFIC_POLICY_LIST_V5,
  DEVICE_LATEST_EOS_VERSION,
  GET_DEVICE_TRANSFER_LOADING,
  GET_DEVICE_TRANSFER,
  SET_DEPLOYED_LISTING_LOADING,
  SET_DEPLOYED_LISTING_COUNT_LOADING,
  SET_CANCEL_DE_REGISTER,
  GET_CANCEL_DE_REGISTER,
  UPGRADE_DEVICE_TO_LATEST_EOS_VERSION_LOADING,
  SET_INVENTORY_SYNC_DATA,
  GET_INVENTORY_SYNC_DATA,
  TRACK_INVENTORY_SYNC_DATA,
  SET_PAUSE_LICENSE,
  GET_PAUSE_LICENSE,
  SET_RESUME_LICENSE,
  GET_RESUME_LICENSE,
  SET_WH_ProdGP_DEVICE_LIST,
  GET_WH_ProdGP_DEVICE_LIST,
  SET_TRANSFER_LICENSE_LOADING,
  GET_TRANSFER_LICENSE,
  SET_CANCEL_PAUSE_LICENSE_LOADING,
  GET_CANCEL_PAUSE_LICENSE,
  SET_ATTACH_DEVICE_TO_SITE_LOADING,
  GET_ATTACH_DEVICE_TO_SITE,
  SET_CREATE_SHARE_CONFIG_LOADING,
  CREATE_SHARE_CONFIG,
  SET_SHARED_CONFIG_PER_CONFIG_LOADING,
  GET_SHARED_CONFIG_PER_CONFIG,
  SET_UPDATE_SHARED_CONFIG_LOADING,
  UPDATE_SHARED_CONFIG,
  SET_DELETE_SHARED_CONFIG_LOADING,
  DELETE_SHARED_CONFIG,
  GET_POLICY_ROUTE_LIST_LOADING,
  GET_POLICY_ROUTE_LIST
 } 
  from "../types";
import { ERROR_ASSING_INVENTORY, ERROR_FETCH_OU_RESOURCES } from "../error_types";
import { toast } from "react-toastify";
import _ from "lodash";
import { ATTACH_DEVICE_TO_SITE_SYNC, CANCEL_DE_REGISTER_SYNC, CANCEL_PAUSE_LICENSE_SYNC, CHANGE_LICENSE_SYNC, DEREGISTRATION_SYNC, DEVICE_MOVEMENT_SYNC, PAUSE_LICENSE_SYNC, REGISTRATION_SYNC, RESUME_LICENSE_SYNC, SITE_MOVEMENT_SYNC, TRANSFER_LICENSE_SYNC } from "../../utils/constants";

export const syncInventoryData = (payload) => async(dispatch) => {
  dispatch({ type: SET_INVENTORY_SYNC_DATA, payload: true })
  let URL = `/store/inventroysync`;
  try {
      let res = await api.postRequestOut(URL, payload);
      dispatch({ type: SET_INVENTORY_SYNC_DATA, payload: false })
      dispatch({ type: GET_INVENTORY_SYNC_DATA, payload: res?.data })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_SYNC_DATA, payload: false })
      return null
  }
}

export const trackInventorySyncStatusData = (siteIds, deviceIds, requestType) => async(dispatch) => {
  dispatch({ type: TRACK_INVENTORY_SYNC_DATA, payload: true })
  let URL = `/store/inventroysync/status`;
  const payload = {
    site_ids: siteIds,
    device_ids: deviceIds,
    request_type: ''
  };
  try {
      let res = await api.postRequestOut(URL, payload);
      dispatch({ type: TRACK_INVENTORY_SYNC_DATA, payload: res?.data })
      return res;
  } catch (error) {
      return null
  }
}

const handleResponseDeployedData = (res, dispatch, dispatcher) => {
  if (res?.data?.error) {
    toast.error('Failed to fetch inventory data..', {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  }
  handleResponse(res, dispatch, dispatcher)
}

export const getInventoryDeployedData = (parameters, dispatcher) => (dispatch) => {
  // let isClickHouse = (window.location.host.includes("devch") || window.location.host.includes("stagech") || window.location.host.includes("prodch"))
  let isClickHouse = true;
  const apiUrl = isClickHouse ? `/store/ch/query` : `/store/ss/query`
  const {pageStart, pagesize, search, sortOrder, dp, k4Ids, sortBy} = parameters;
  dispatch({ type: SET_DEPLOYED_LISTING_LOADING, payload: true });
  const vesselMap: any = [];
    k4Ids?.map((item: any) => {
      let vesselName = item["id"];
      vesselMap.push(vesselName);
    })  
  let k4idhere = vesselMap.length > 0 ? `${"'" + vesselMap.join("','") + "'"}` : null;
  let _userOu :any = localStorage.getItem('user_ou');
  const userOu = JSON.parse(_userOu)
  const data : any = {
    query: 'INVENTORY_DASHBOARD_V2',
    named: true,
    parameters: {
      pageStart : pageStart,
      pagesize : pagesize,
      search : search,
      sortBy: sortBy,
      sortOrder : sortOrder,
      dp : "",
      k4Ids : (k4idhere && k4idhere !== '') ? `${k4idhere}` : '',
      deregQ: parameters.deregQ || "",
      org: userOu?.name || ""
    },
    format: 'csv'
  }
  api
  .postRequestOut(`${apiUrl}`, data)
  .then((res) => 
  handleResponseDeployedData(res, dispatch, dispatcher))
  .catch((err) => handleError(err, dispatch));
};

export const getInventoryDeployedDataCount = (parameters) => (dispatch) => {
  // let isClickHouse = (window.location.host.includes("devch") || window.location.host.includes("stagech") || window.location.host.includes("prodch"))
  let isClickHouse = true;
  const apiUrl = isClickHouse ? `/store/ch/query` : `/store/ss/query`
  const {pageStart, pagesize, search, sortOrder, dp, k4Ids} = parameters;
  dispatch({ type: SET_DEPLOYED_LISTING_COUNT_LOADING, payload: true });
  const vesselMap: any = [];
    k4Ids?.map((item: any) => {
      let vesselName = item["id"];
      vesselMap.push(vesselName);
    })  
  let k4idhere = vesselMap.length > 0 ? `${"'" + vesselMap.join("','") + "'"}` : null;
  const data : any = {
    query: 'INVENTORY_DASHBOARD_COUNT',
    named: true,
    parameters: {
      pageStart : pageStart,
      pagesize : pagesize,
      search : search,
      sortOrder : sortOrder,
      dp : "",
      k4Ids : (k4idhere && k4idhere !== '') ? `${k4idhere}` : '',
       deregQ: parameters.deregQ || ""
    },
    format: 'csv'
  }
  api
  .postRequestOut(`${apiUrl}`, data)
  .then((res) => 
  handleResponse(res, dispatch, GET_INVENTORY_DEPLOYED_DATA_COUNT))
  .catch((err) => handleError(err, dispatch));
};

// List all T0 and T91 (open edge) sites
export const getT0AndOpenEdgeData = (parameters, dispatcher) => (dispatch) => {
  let isClickHouse = true;
  const apiUrl = isClickHouse ? `/store/ch/query` : `/store/ss/query`
  const {dpId} = parameters;
  dispatch({ type: SET_T0_AND_OPEN_EDGE_LOADING, payload: true });
  const data : any = {
    query: 'GET_T0_AND_OPEN_EDGE_SITES',
    named: true,
    parameters: {
      dp_id : dpId,
    },
    format: 'json'
  }
  api
  .postRequestOut(`${apiUrl}`, data)
  .then((res) => 
    handleResponse(res, dispatch, dispatcher, "", SET_T0_AND_OPEN_EDGE_LOADING))
  .catch((err) => handleError(err, dispatch));
};


export const getInventoryWarehouseTableData = ( ouId="", searchValue="", page=-1, limit=-1, sortBy,sortOrder) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
    .getRequestForExternalApi(`${KAPTUREV2_URL_INV}dp/inventoryList?k4DpId=${ouId}&searchValue=${searchValue}&pageNumber=${page}&pageSize=${limit}&sortKey=${sortBy}&sortOrder=${sortOrder}`)
    .then((res) => handleResponse(res, dispatch, GET_INVENTORY_WAREHOUSE_TABLE_DATA))
    .catch((err) => handleError( err, dispatch));
};

export const getInventoryWarehouseVesselList = (ouName, searchValue:"", viewWarehouseService:any, viewwarehouseFunction:any) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
    .getRequestOut(`/edge/distributionPartners/dpName/${ouName}/locations?search=${searchValue}&sort=name&sortOrder=asc&service=${viewWarehouseService}&service_function=${viewwarehouseFunction}`)
    .then((res) => handleResponse(res, dispatch, GET_INVENTORY_WAREHOUSE_VESSEL_LIST, ERROR_FETCH_OU_RESOURCES, SET_INVENTORY_LISTING_LOADING))
    .catch((err) => handleError( err, dispatch));
}

export const getDeviceLatestEOSversion = (deviceId) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
    .getRequestOut(`/edge/softwares/sites/devices/${deviceId}/getLatestStableEosVersion`)
    .then((res) => handleResponse(res, dispatch, DEVICE_LATEST_EOS_VERSION))
    .catch((err) => handleError(err, dispatch));
}

export const upgradeDevicetoLatestEOSversion = (siteId, deviceId, scheduled_time) => async(dispatch) => {
  dispatch({ type: UPGRADE_DEVICE_TO_LATEST_EOS_VERSION_LOADING, payload: true })

  let URL = `/v1/sites/${siteId}/devices/${deviceId}/software/upgrade`
  let payload = {
    "site_id": siteId,
    "device_id": deviceId,
    "scheduled_time": scheduled_time ? scheduled_time : undefined
  }

  try {
      let res = await api.siteController.post(URL, payload);
      if(res && res?.success == true) {
        toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      else{
        let response = res?.data? res.data: res;
        let message = response?.result ? response.result :"Failed to initiate Upgrade on the device"
        toast.error(message, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      dispatch({ type: UPGRADE_DEVICE_TO_LATEST_EOS_VERSION_LOADING, payload: false })
      dispatch({ type: UPGRADE_DEVICE_TO_LATEST_EOS_VERSION, payload: res?.result })
      return res;
  } catch (error) {
      dispatch({ type: UPGRADE_DEVICE_TO_LATEST_EOS_VERSION_LOADING, payload: false })
      return null
  }
}

export const upgradeWarehouseDevicetoLatestEOSversion = (dpId, deviceId) => async(dispatch) => {
  dispatch({ type: SET_UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION_LOADING, payload: true })
  let URL = `/v1/sites/warehouse/dp/${dpId}/devices/${deviceId}/software/upgrade`
  try {
      let res = await api.siteController.post(URL, {});
      if(res && res?.success == true) {
        toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      else{
        let response = res?.data? res.data: res;
        let message = response?.result ? response.result :"Failed to initiate Upgrade on the device"
        toast.error(message, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      dispatch({ type: SET_UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION_LOADING, payload: false })
      dispatch({ type: UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION, payload: res?.result })
      return res;
  } catch (error) {
      dispatch({ type: SET_UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION_LOADING, payload: false })
      return null
  }
}

export const getDeviceList = (ouName) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = "/edge/locations"
  if(!_.isEmpty(ouName)){
    URL+="?ouName="+ouName
  }
  api
    .getRequestOut(URL)
    .then((res) => handleResponse(res, dispatch, GET_DEVICE_LIST))
    .catch((err) => handleError(err, dispatch));
}

export const getSiteDevices = (dpId: string) => (dispatch) => {
  if (!dpId) return;
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  const payload = {
    query: "GET_DP_DEVICES",
    named: true,
    parameters: { dp_id: dpId },
    format: "csv"
  };
  api
    .postRequestOut(`/store/ch/query`, payload)
    .then((res) => handleResponse(res, dispatch, GET_DP_DEVICES))
    .catch((err) => handleError(err, dispatch));
}

export const createGroup = (dpId, payload) => async (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/dps/${dpId}/group`;
  try {
      let res = await api.siteController.post(URL, payload);
      groupToastMessage(res,"Group created successfully")
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: CREATE_INVENTORY_GROUP, payload: res })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      return null;
  }
};

const groupToastMessage = (res,message) =>{
  if(res && res.success == true) {
    toast.success(message, {
        position: toast.POSITION.BOTTOM_LEFT,
    });
  }
  else if (res && res.success == false) {
    if (Array.isArray(res.errors) && res.errors.length > 0) {
      toast.error(res.errors[0].message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  }
}

export const updateGroup = (dpId, payload) => async (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/dps/${dpId}/group`;
  try {
      let res = await api.siteController.put(URL, payload);
      groupToastMessage(res,"Group updated successfully")
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: UPDATE_INVENTORY_GROUP, payload: res })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      return null;
  }
};

export const deleteGroup = (dpId, groupId) => async (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/dps/${dpId}/group/${groupId}`;
  try {
      let res = await api.siteController.delete(URL);
      groupToastMessage(res,"Group deleted successfully")
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: DELETE_INVENTORY_GROUP, payload: res })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      return null;
  }
};

export const groupDevicesEosUpgrade = (dpId, groupId) => async (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/dps/${dpId}/group/${groupId}/action/software/upgrade`;
  try {
      let res = await api.siteController.post(URL);
      groupToastMessage(res,"Initiated the software upgrade on devices")
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: INVENTORY_GROUP_DEVICES_EOS_UPGRADE, payload: res })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      return null;
  }
};

export const getGroupList = (payload) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) =>
      handleResponse(res, dispatch, GET_INVENTORY_GROUP_LIST))
    .catch((err) => handleError(err, dispatch));
}

export const getGroupListCount = (payload) => (dispatch) => {  
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) =>
      handleResponse(res, dispatch, GET_INVENTORY_GROUP_LIST_COUNT))
    .catch((err) => handleError(err, dispatch));
}

export const getSiteInfo = (payload) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
    .postRequestOut(`/store/ch/query`, payload)
    .then((res) =>
      handleResponse(res, dispatch, GET_SITE_INFO_LIST))
    .catch((err) => handleError(err, dispatch));
}

export const getSiteInfoCount = (payload) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
    .postRequestOut(`/store/ch/query`, payload)
    .then((res) =>
      handleResponse(res, dispatch, GET_SITE_INFO_LIST_COUNT))
    .catch((err) => handleError(err, dispatch));
}

export const assignInventoryToVessel = (deviceId, payload) => (dispatch) => {
  const syncPayload = {
    site_ids: [], device_ids: [deviceId], request_type: REGISTRATION_SYNC
  }
    dispatch({ type: SET_ASSIGN_INVENTORY_TO_VESSEL, payload: true });
    api
      .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/updateInventoryLocation/v5?deviceId=${deviceId}`, payload, syncPayload, dispatch)
        .then((res) => showToastMessage(res, dispatch, ASSIGN_INVENTORY_TO_VESSEL))
        .catch((err) => handleError(err, dispatch));
};

export const getLicenseTypes = (dpId, deviceId) => (dispatch) => {
  dispatch({ type: SET_LICENSE_TYPES, payload: true });
  api
    .getRequestForExternalApi(`${KAPTUREV2_URL_INV}inventoryConfig/getLicenseTypes/v2?dpId=${dpId}&deviceId=${deviceId}`)
    .then((res) => handleResponse(res, dispatch, GET_LICENSE_TYPES))
    .catch((err) => handleError( err, dispatch));
};

export const getDpsDefaultActiveConfig = (dpId, deviceId) => (dispatch) => {
  if (_.isEmpty(deviceId) || _.isEmpty(dpId)){
    return
  }

  const data = {
    query: `GET_DPS_DEFAULT_ACTIVE_CONFIG`,
    named: true,
    format: 'json',
    parameters: {
      "device_identifier": deviceId.slice(0, 2),
      "dp_id": dpId
    }
  }
  api
    .postRequestOut(`/store/pg/query`, data)
    .then((res) => {
      handleResponse(res, dispatch, GET_DPS_DEFAULT_ACTIVE_CONFIG)
    })
    .catch((err) => {
      handleError(err, dispatch);
    });
};

const handlCreateVesselRes = (res, dispatch, dispatcher) => {
  if (res.status !== 201) {
    toast.error(res.message, {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  }
  else if (res.status == 201 && res?.data?.status == 1) {
    toast.success(res?.data?.message, {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  }
  handleResponse(res, dispatch, dispatcher)
}

export const createVessel = (userEmail, payload) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
      .postRequestForExternalApi(`${KAPTUREV2_URL}/location/create?userEmail=${userEmail}`, payload)
      .then((res) => {
        handlCreateVesselRes(res, dispatch, CREATE_AND_ASSIGN_INVENTORY)
      })
      .catch((err) => handleError(err, dispatch));
};

export const getDPList = (search="") => (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  api
    .getRequest(`/iam/v3/ou/derived?search=${search}&sort=name&sortOrder=asc`)
      .then((res) => handleResponse(res, dispatch, GET_DP_LIST))
      .catch((err) => handleError(err, dispatch));
};

export const moveDeviceToWarehouse = (deviceId, payload) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE, payload: true });
  const syncPayload = {
    site_ids: [], device_ids: [deviceId], request_type: DEREGISTRATION_SYNC
  }
    api
      .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/updateInventoryLocation/v5?deviceId=${deviceId}`,payload, syncPayload, dispatch)
      .then((res) => showToastMessage(res, dispatch, INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE))
      .catch((err) => handleError(err, dispatch));
};

export const inventoryChangeGroup = (k4Id, dpId) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  const payload = {
    k4DpId: dpId
  }
  const syncPayload = {
    site_ids: [k4Id], device_ids: [], request_type: SITE_MOVEMENT_SYNC
  }
  api
      .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}vessels/moveToDP?k4Id=${k4Id}`, payload, syncPayload, dispatch)
      .then((res) => showToastMessage(res, dispatch, INVENTORY_CHANGE_GROUP))
      .catch((err) => handleError(err, dispatch));
};

export const warehouseChangeGroup = (dpId, deviceId) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  const payload = {
    dpId: dpId
  }
  api
      .postRequestForExternalApi(`${KAPTUREV2_URL_INV}inventoryConfig/updateInventoryLocation/v5?deviceId=${deviceId}`, payload)
      .then((res) => showToastMessage(res, dispatch, INVENTORY_WAREHOUSE_CHANGE_GROUP))
      .catch((err) => handleError(err, dispatch));
};

export const deleteSite = (siteId) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  api
      .deleteRequestForExternalApi(`${KAPTUREV2_URL_INV}vessels/delete/${siteId}`)
      .then((res) => showToastMessage(res, dispatch, INVENTORY_DELETE_SITE))
      .catch((err) => handleError(err, dispatch,));
};

export const showToastMessage = (res, dispatch, handler) => {
  const ssDbSyncTime= " Changes may take time upto 30 secs."
  let message = ""
  let success = false;
  if(res.status == 200 && res.data.status == 1 && (res.data.hasOwnProperty('error_code') && res.data.error_code != 10011 && res.data.error_code != 10035 && res.data.error_code != 10015 && res.data.error_code != 10043 && res.data.error_code != 10055 && res.data.error_code != 12016 && res.data.error_code != 20019 && res.data.error_code != 20018) ) {
    success = true;
    message = res.data.message;
    if (handler == ASSIGN_INVENTORY_TO_VESSEL) {
       message = `${message}, The device may take up to 5 minutes to come online.`
    }
  } else if (res.status == 200) {
    if(handler == INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE){
      message = res.data.message;
    } else if(handler == INVENTORY_DELETE_SITE){
      message = "Successfully deleted the site."+ssDbSyncTime
    } else if(handler == INVENTORY_WAREHOUSE_CHANGE_GROUP){
      message = res.data?.message;
    } else {
      message = res.data.message;
    }
    if (res.hasOwnProperty("data") && res.data.hasOwnProperty("status") && res.data.status == 1){
      if(res.data.hasOwnProperty('error_code') && (res.data.error_code == 10011 || res.data.error_code == 10035 || res.data.error_code == 10015 || res.data.error_code == 10043 || res.data.error_code == 10055 || res.data.error_code == 12016  || res.data.error_code == 20019 || res.data.error_code == 20018)) {
        success = false;
      } else {
        success = true;
      }
    }
  } else {
    if (res.hasOwnProperty("message")){
      message = res.message
    }else {
      message = res
    }
  }

  if (success){
    toast.success(message, {
      position: toast.POSITION.BOTTOM_LEFT,
    })
  } else if(res.data.hasOwnProperty('error_code') && (res.data.error_code != 10011 && res.data.error_code != 10035 && res.data.error_code != 10015 && res.data.error_code != 10043 && res.data.error_code != 10055 && res.data.error_code != 12016 && res.data.error_code != 20019 && res.data.error_code != 20018)) {
    toast.error(message, {
      position: toast.POSITION.BOTTOM_LEFT,
    })
  }
  handleResponse(res, dispatch, handler)
}

export const getInventoryTopWidgetsRegisteredCount = (ouId,ouName) => (dispatch) => {
  if (ouId.toLowerCase() == "dp-0001") {
    ouName = "ALL"
  }

  dispatch({ type: SET_LOADING, payload: true });
  api
    .getRequestForExternalApi(`${KAPTUREV2_URL_INV}nodesReport/getRegDIDsCount?dp_id=${ouId}`)
    .then((res) => handleResponse(res, dispatch, INVENTORY_TOP_WIDGETS_REGISTERED_COUNT))
    .catch((err) => handleError(err, dispatch));
}

export const getInventoryTopWidgetKassCount = (ouId,ouName) => (dispatch) => {
  let dpCheck = true

  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth()+1
  let todaysDate = date.getDate()
  let startDateOfMonth = "01"

  let startDate = year + "-" + month + "-" + startDateOfMonth
  let endDate = year + "-" + month + "-" + todaysDate

  if (ouId.toLowerCase() == "dp-0001") {
    ouName = ""
    dpCheck = false

  }
  dispatch({ type: SET_LOADING, payload: true });
  api
    .getRequestForExternalApi(`${KAPTUREV2_URL_INV}nodesReport/getNodesData?recType=kaasLicences&startDate=${startDate}&endDate=${endDate}&pageNumber=1&pageSize=5&vslName=${ouName}&dpCheck=${dpCheck}`)
    .then((res) => handleResponse(res, dispatch, INVENTORY_TOP_WIDGET_KAAS_COUNT))
    .catch((err) => handleError(err, dispatch));
}

export const getInventoryTopWidgetWarehouseCount = (ouId) => (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  api
    .getRequestForExternalApi(`${KAPTUREV2_URL_INV}dp/inventoryList?k4DpId=${ouId}&pageNumber=1&pageSize=5`)
    .then((res) => handleResponse(res, dispatch, INVENTORY_TOP_WIDGETS_WAREHOUSE_COUNT))
    .catch((err) => handleError( err, dispatch));
}

export const inventoryDownloadConfig = (siteId, deviceId, configId) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/sites/${siteId}/devices/${deviceId}/configuration/${configId}/download`;
  api.siteController.get(URL)
      .then((res) => {
          dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
          dispatch({ type: INVENTORY_DOWNLOAD_CONFIG, payload: res })
      })
      .catch((err) => {
          dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      });
}

export const clearInventoryConfigDownload = () => (dispatch) => {
  dispatch({ type: INVENTORY_DOWNLOAD_CONFIG})
}

export const getConfigProducts = (dpId, deviceType) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  const data: any = {
      query: "PRODUCT_DEFAULT_CONFIG",
      named: true,
      parameters: {
          dp_id: dpId,
          device_type: deviceType
      },
      format: "csv"
  }
  api
  .postRequestOut(`/store/ss/query`, data)
  .then((res) =>
  handleResponse(res, dispatch, GET_CONFIG_PRODUCTS))
  .catch((err) => handleError(err, dispatch));
}

export const applyGoldenConfig = (payload) => async (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/sites/devices/configuration/apply`;
  try {
      let res = await api.siteController.post(URL, payload);
      if(res && res.success == true) {
        toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      else if(res && res.success == false) {
        toast.error(res.errors.message, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: APPLY_GOLDEN_CONFIG, payload: res?.result })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      return null;
  }
};

export const postDeviceResgistrationActions = (siteId, deviceId, payload) => async (dispatch) => {
  let URL = `/v1/sites/${siteId}/devices/${deviceId}/v2/postResgistrationActions`;
  try {
      let res = await api.siteController.post(URL, payload);
  } catch (error) {
      return null;
  }
};

export const backupConfigNow = (siteId, deviceId, deviceName, configName) => async (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let payload = {
    "config_name": configName
  }

  let URL = `/v1/sites/${siteId}/devices/${deviceId}/configuration/backup`;
  try {
    let res = await api.siteController.post(URL, payload);

    let success = false;
    let success_message = `Started the configuration backup for ${deviceName}`
    let failed_message = `Failed to take the configuration backup for ${deviceName}`
    let message = failed_message
    if (res && res.hasOwnProperty("success")) {
      if (res.success == true) {
        success = true;
        message = success_message
      }
    } else if (res && res.hasOwnProperty("data")) {
      if (!_.isEmpty(res.data) && res.data.hasOwnProperty("success") && res.data.success == true) {
        success = true;
        message = success_message
      }
    }

    if (success == true) {
      toast.success(message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } else {
      toast.error(message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }

    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    dispatch({ type: BACKUP_CONFIG_NOW, payload: res })
    return res;
  } catch (error) {
    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    return null;
  }
};

export const getTrafficPolicyData = (payload) => (dispatch) => {
  dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: true });
  

  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) => {
      dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: false })
      return handleResponse(res, dispatch, GET_TRAFFIC_POLICY_LIST)
    })
    .catch((err) => handleError(err, dispatch));
}

export const getPolicyRouteData = (payload) => (dispatch) => {
  dispatch({ type: GET_POLICY_ROUTE_LIST_LOADING, payload: true });
  
  const data: any = {
      query: "GET_POLICY_ROUTES",
      named: true,
      parameters: {
          k4Id: payload.k4Id,
          deviceId: payload.deviceId
      },
      format: "json"
  }
  api
    .postRequestOut(`/store/pg/query`, data)
    .then((res) => {
      dispatch({ type: GET_POLICY_ROUTE_LIST_LOADING, payload: false })
      return handleResponse(res, dispatch, GET_POLICY_ROUTE_LIST)
    })
    .catch((err) => handleError(err, dispatch));
}

export const applyTrafficPolicy = (payload) => async (dispatch) => {
  dispatch({ type: APPLY_TRAFFIC_POLICY_LOADING, payload: true });
  let URL = `/v1/sites/trafficpolicy/apply`;
  try {
    let res = await api.siteController.post(URL, payload);
    if(res && res.success === true) {
        toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      } else if(res && res.success === false) {
        let errMessage = res?.result ? res.result : "Something went wrong.";
        toast.error(errMessage, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
    }
    dispatch({ type: APPLY_TRAFFIC_POLICY_LOADING, payload: false });
    dispatch({ type: APPLY_TRAFFIC_POLICY, payload: res?.result });
    return res;
  } catch (error) {
    dispatch({ type: APPLY_TRAFFIC_POLICY_LOADING, payload: false })
    return null;
  }
}

export const applyPolicyRoute = (payload) => async (dispatch) => {
  dispatch({ type: APPLY_POLICY_ROUTE_LOADING, payload: true });
  let URL = `/v1/sites/policyroute/apply`;
  try {
    let res = await api.siteController.post(URL, payload);
    if(res && res.success === true) {
        toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      } else if(res && res.success === false) {
        let errMessage = res?.result ? res.result : "Something went wrong.";
        toast.error(errMessage, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
    }
    dispatch({ type: APPLY_POLICY_ROUTE_LOADING, payload: false });
    dispatch({ type: APPLY_POLICY_ROUTE, payload: res?.result });
    return res;
  } catch (error) {
    dispatch({ type: APPLY_POLICY_ROUTE_LOADING, payload: false })
    return null;
  }
}

export const getTraficPolicyApplyLogs = (payload) => (dispatch) => {
  dispatch({ type: GET_TRAFFIC_POLICY_LOG_LIST_LOADING, payload: true });

  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) => {
      dispatch({ type: GET_TRAFFIC_POLICY_LOG_LIST_LOADING, payload: false })
      return handleResponse(res, dispatch, GET_TRAFFIC_POLICY_LOG_LIST)
    })
    .catch((err) => handleError(err, dispatch));
}

export const applyFirewallRule = (payload) => async (dispatch) => {
  dispatch({ type: APPLY_FIREWALL_RULE_LOADING, payload: true });
  let URL = `/v1/sites/firewallrules/apply`;

  try {
    let res = await api.siteController.post(URL, payload);
    if(res && res.success === true) {
        toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      } else if(res && res.success === false) {
        let errMessage = res?.result ? res.result : "Something went wrong.";
        toast.error(errMessage, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
    } else if(res && res?.data && res?.data?.result) {
      toast.error(res?.data?.result, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    dispatch({ type: APPLY_FIREWALL_RULE_LOADING, payload: false });
    dispatch({ type: APPLY_FIREWALL_RULE, payload: res?.result });
  } catch (error) {
    dispatch({ type: APPLY_FIREWALL_RULE_LOADING, payload: false })
  }
}

export const getWANProfileList = (payload) => async (dispatch) => {
  dispatch({ type: GET_WAN_PROFILE_LISTING_LOADING, payload: true });
  

  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) => {
      dispatch({ type: GET_WAN_PROFILE_LISTING_LOADING, payload: false })
      return handleResponse(res, dispatch, GET_WAN_PROFILE_LIST)
    })
    .catch((err) => handleError(err, dispatch));
} 

export const applyWanProfile = (payload) => async (dispatch) => {
  dispatch({ type: APPLY_WAN_PROFILE_LOADING, payload: true });

  let URL = `/v1/sites/wanprofiles/apply`;
  try {
    let res = await api.siteController.post(URL, payload);
    if (res && res.success === true) {
      toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
      });
    } else if (res && res.success === false) {
      let errMessage = res?.result ? res.result : "Something went wrong.";
      toast.error(errMessage, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
    }
    dispatch({ type: APPLY_WAN_PROFILE_LOADING, payload: false });
    dispatch({ type: APPLY_WAN_PROFILE, payload: res?.result });
  } catch (error) {
    dispatch({ type: APPLY_WAN_PROFILE_LOADING, payload: false })
    return null;
  }
}

export const getPopIpsList = (payload) => async (dispatch) => {
  dispatch({ type:  GET_POP_IPS_LISTING_LOADING, payload: true });

  api
    .postRequestOut('/store/pg/query', payload)
    .then((res) => {
      dispatch({ type: GET_POP_IPS_LISTING_LOADING, payload: true});
      return handleResponse(res, dispatch, GET_POP_IPS_LIST);
    })
    .catch((err) => handleError(err, dispatch));
}

export const applyHubIPConfig = (payload) => async (dispatch) => {
  dispatch({ type:APPLY_HUB_IP_CONFIG_LOADING, payload: true });

  let URL = `/v1/sites/hubipconfig/apply`;
  try {
    let res = await api.siteController.post(URL, payload);
    if (res && res.success === true) {
      toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
      });
    } else if (res && res.success === false) {
      let errMessage = res?.result ? res.result : "Something went wrong.";
      toast.error(errMessage, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
    }

    dispatch({ type: APPLY_HUB_IP_CONFIG_LOADING, payload: false });
    dispatch({ type: APPLY_HUB_IP_CONFIG, payload: res?.result });
  } catch (error) {
    dispatch({ type: APPLY_WAN_PROFILE_LOADING, payload: false })
    return null;
  }
}

export const copyQuotaConfig = (payload) => async (dispatch) => {
  dispatch({ type:COPY_QUOTA_CONFIG_LOADING, payload: true });

  let URL = `/v1/sites/quota/copy`;
  try {
    let res = await api.siteController.post(URL, payload);
    if (res && res.success === true) {
      toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
      });
    } else if (res && res.success === false) {
      let errMessage = res?.result ? res.result : "Something went wrong.";
      toast.error(errMessage, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
    }

    dispatch({ type: COPY_QUOTA_CONFIG_LOADING, payload: false });
    return res;
  } catch (error) {
    dispatch({ type: COPY_QUOTA_CONFIG_LOADING, payload: false })
    return null;
  }
}

export const backupConfigData = (k4Ids, page, limit, search, sort, sortOrder, deviceId, deviceType, softwareVersion, manual, status, dpId) => (dispatch) => {
  dispatch({ type: SET_BACKUP_CONFIG_DATA_LOADING, payload: true });

  let URL = manual ? "/edge/sites/devices/configuration/pg/query" : "/edge/sites/devices/configuration/query"

  let payload = {
    "site_id": k4Ids,
    "device_id": deviceId,
    "device_type": deviceType,
    "search": search,
    "page": page,
    "size": limit,
    "sort_by": sort,
    "sort_order": sortOrder,
    "software_version": softwareVersion,
    "status": status,
    "ou_id": manual ? dpId : undefined,
  }

  if (manual != undefined) {
    payload["manual"] = manual
  }
  if(k4Ids && k4Ids.length > 0) {


  api.postRequestNormal(URL, payload)
    .then((res) => {
      dispatch({ type: SET_BACKUP_CONFIG_DATA_LOADING, payload: false })
      dispatch({ type: GET_BACKUP_CONFIG_DATA, payload: res })
    })
    .catch((err) => {
      dispatch({ type: SET_BACKUP_CONFIG_DATA_LOADING, payload: false })
    });
  } else {
    dispatch({ type: SET_BACKUP_CONFIG_DATA_LOADING, payload: false })
    dispatch({ type: GET_BACKUP_CONFIG_DATA, payload: {} })
  }
};

export const copyConfigToManualBackup = (siteId, deviceId, configId, newConfigName) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/sites/${siteId}/devices/${deviceId}/configuration/${configId}`;
  let payload = {
    "config_name": newConfigName,
    "copy": true
  }
  api.siteController.put(URL, payload)
    .then((res) => {
      if (res && res.success == true) {
        toast.success('Successfully copied to backup configuration', {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }else {
        toast.error('Failed to copy the configuration to backup configuration', {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: COPY_CONFIG_TO_MANUAL_BACKUP, payload: res })
    })
    .catch((err) => {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    });
};

export const deleteManualBackupConfig = (siteId, deviceId, configId, configName) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/sites/${siteId}/devices/${deviceId}/configuration/${configId}`;
  api.siteController.delete(URL)
    .then((res) => {
      if (res && res.success == true) {
        toast.success(`Successfully deleted the backup configuration: ${configName}`, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }else {
        toast.error(`Failed to delete the backup configuration: ${configName}`, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: DELETE_MANUAL_BACKUP_CONFIG, payload: res })
    })
    .catch((err) => {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    });
};

export const editDefaultConfig = (dpId, configId, payload) => async (dispatch) => {
    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
    let URL = `/v1/dps/${dpId}/default_configurations/${configId}`;
    try {
        let res = await api.siteController.put(URL, payload);
        if(res && res.success == true) {
          toast.success('Default Config Updated Successfully..', {
              position: toast.POSITION.BOTTOM_LEFT,
          });
        }
        dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
        dispatch({ type: EDIT_DEFAULT_CONFIG, payload: res })
        return res;
    } catch (error) {
        dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
        return null;
    }
};

export const createDefaultConfig = (dpId, payload) => async (dispatch) => {
    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
    let URL = `/v1/dps/${dpId}/default_configurations`;
    try {
        let res = await api.siteController.post(URL, payload);
        if(res && res.success == true) {
            toast.success('Default Config Created Successfully..', {
                position: toast.POSITION.BOTTOM_LEFT,
            });
        }
        dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
        dispatch({ type: CREATE_DEFAULT_CONFIG, payload: res })
        return res;
    } catch (error) {
        dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
        return null;
    }
};

export const deleteDefaultConfig = (dpId, id) => async (dispatch) => {
    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
    let URL = `/v1/dps/${dpId}/default_configurations/${id}`;
    try {
        let res = await api.siteController.delete(URL);
        dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
        dispatch({ type: DELETE_DEFAULT_CONFIG, payload: res })
        if(res?.result) {
          toast.success('Config Deleted Successfully..', {
              position: toast.POSITION.BOTTOM_LEFT,
          });
      }
        return res;
    } catch (error) {
        dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
        return null;
    }
};

export const getDefaultConfigListing = (dpIds, page, limit, sort, sortOrder, searchValue) => async (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/dps/default_configurations`;
  const payload = {
    dp_id: dpIds,
    search: searchValue,
    sort_by: sort,
    sort_order: sortOrder,
    page: page,
    size: limit,
    show_product_config: false,
    show_dp_name: true
  }
  if(dpIds && dpIds.length > 0 ) {

  
  try {
      let res = await api.siteController.post(URL, payload);
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: GET_DEFAULT_CONFIG_LISTING, payload: res })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      return null;
  }
  } else {
    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    dispatch({ type: GET_DEFAULT_CONFIG_LISTING, payload: {} })
  }
};

export const getDefaultProducts = (configId) => async (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  let URL = `/v1/dps/default_configurations/product_configuration`;
  const payload = {
    default_config_id: [`${configId}`],
    show_names: true,
    page: 1,
    size: 1000
  }
  try {
      let res = await api.siteController.post(URL, payload);
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: GET_DEFAULT_PRODUCTS, payload: res?.result })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      return null;
  }
};

export const getConfigSoftwareVersions = () => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  const softwareVersions : any = {
      query: 'GET_CONFIG_BACKUP_SOFTWARE_VERSIONS',
      named: true,
      format: 'csv'
  }
  api
  .postRequestOut(`/store/ss/query`, softwareVersions)
  .then((res) => handleResponse(res, dispatch, GET_CONFIG_SOFTWARE_VERSIONS))
  .catch((err) => {
    handleError(err, dispatch);
    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false });
  });
}

export interface getConfigStatusParameters {
  sites: string[];
  search: string;
  sort: string;
  order: string;
  limit: number;
  offset: number;
}

export const getConfigStatus = (parameters: getConfigStatusParameters) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true })
  let _parameters: any = { ...parameters };
  _parameters.sites = _parameters?.sites.map(site => `'${site}'`).join(',');
  const data = {
    query: `GET_CONFIG_RESTORE_STATUS`,
    named: true,
    format: 'csv',
    parameters: _parameters
  }
  api
    .postRequestOut(`/store/pg/query`, data)
    .then((res) => {
      handleResponse(res, dispatch, GET_CONFIG_STATUS)
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    })
    .catch((err) => {
      handleError(err, dispatch);
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    });
}

export const getGroupTranscationConfigStatus = (sites, devices, groupTransactionId, searchText, sortBy, sortOrder, page, size) => (dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true })

  let payload = {
    "query": "GET_GROUP_TRANSCATION_CONFIG_RESTORE_STATUS",
    "named": true,
    "parameters": {
      "sites": sites,
      "devices": devices,
      "group_transaction_id": groupTransactionId,
      "search": searchText,
      "sort": sortBy,
      "order": sortOrder,
      "limit": size,
      "offset": (page - 1) * size
    },
    "format": "csv"
  }

  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) => {
      handleResponse(res, dispatch, GET_GROUP_TRANSCATION_CONFIG_STATUS)
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    })
    .catch((err) => {
      handleError(err, dispatch);
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
    });
}

export const rebootDevice = (siteId, deviceId) => async(dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true })

  let URL = `/v1/sites/${siteId}/device/${deviceId}/reboot`
  let payload = {}

  try {
      let res = await api.siteController.post(URL, payload);
      if(res && res.success == true) {
        toast.success(res.result, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      else if(res && res.success == false) {
        toast.error(res.errors.message, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      dispatch({ type: REBOOT_DEVICE, payload: res?.result })
      return res;
  } catch (error) {
      dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false })
      return null
  }
}

export const inventoryDeviceHistory = (invId, page, limit) => (dispatch) => {
  dispatch({ type: SET_DEVICE_HISTORY_LOADING, payload: true });
  api
      .getRequestForExternalApi(`${KAPTUREV2_URL_INV}inventoryConfig/inventoryHistory/v2?inventoryId=${invId}&pageNumber=${page}&pageSize=${limit}`)
      .then((res) => handleResponse(res, dispatch, GET_DEVICE_HISTORY))
      .catch((err) => {
        dispatch({ type: SET_DEVICE_HISTORY_LOADING, payload: false });
        handleError(err, dispatch)
      });
};

export const getDeviceConfigActionLogs = (deviceId) => (dispatch) => {
  dispatch({ type: SET_DEVICE_CONFIG_ACTION_LOGS_LOADING, payload: true });
  let payload ={
    "query": "GET_DEVICE_CONFIG_ACTION_LOGS",
    "named": true,
    "parameters": {
        "deviceId": deviceId,
    },
    "format": "csv"
}
  api
      .postRequestOut(`/store/pg/query`, payload)
      .then((res) => handleResponse(res, dispatch, GET_DEVICE_CONFIG_ACTION_LOGS))
      .catch((err) => {
        dispatch({ type: SET_DEVICE_CONFIG_ACTION_LOGS_LOADING, payload: false });
        handleError(err, dispatch)
      });
};

export const getDeviceEosHistoryEvents = (deviceId) => (dispatch) => {
  dispatch({ type: SET_DEVICE_EOS_HISTORY_EVENTS_LOADING, payload: true });
  let payload ={
    "query": "GET_DEVICE_UPGRADE_EVENTS",
    "named": true,
    "parameters": {
        "deviceIds": `'${deviceId}'`,
    },
    "format": "csv"
}
  api
      .postRequestOut(`/store/ch/query`, payload)
      .then((res) => handleResponse(res, dispatch, GET_DEVICE_EOS_HISTORY_EVENTS))
      .catch((err) => {
        dispatch({ type: SET_DEVICE_EOS_HISTORY_EVENTS_LOADING, payload: false });
        handleError(err, dispatch)
      });
};

export const getDeviceLicenseHistory = (siteId,deviceId) => async (dispatch) => {
  dispatch({ type: SET_DEVICE_LICENSE_HISTORY_LOADING, payload: true });
  let URL = `/v1/sites/${siteId}/devices/${deviceId}/license/history`
  let payload = {}

  try {
      let res = await api.siteController.get(URL, payload);
      dispatch({ type: SET_DEVICE_LICENSE_HISTORY_LOADING, payload: false })
      dispatch({ type: GET_DEVICE_LICENSE_HISTORY, payload: res?.result })
      return res;
  } catch (error) {
      dispatch({ type: SET_DEVICE_LICENSE_HISTORY_LOADING, payload: false })
      return null
  }
};

export const handleToastMessage = (res, dispatch, handler) => {
  let message = ""
  let success = false;
  if (res.status == 200 && res.data.status == 1 && (res.data.hasOwnProperty('error_code') && (res.data.error_code != 14013 && res.data.error_code != 14014 && res.data.error_code != 14015 && res.data.error_code != 14016 && res.data.error_code != 14019 && res.data.error_code != 14029 && res.data.error_code != 12000 && res.data.error_code != 12016 && res.data.error_code != 12022 && res.data.error_code != 11035 && res.data.error_code != 11034 && res.data.error_code != 18014))) {
    success = true;
    message = res.data.message;
  } else if (res.status == 200) {
    if (handler == GET_UPGRADE_INVENTORY_LICENSE) {
      message = res.data.message;
    } else {
      message = res.data.message;
    }
    if (res.hasOwnProperty("data") && res.data.hasOwnProperty("status") && res.data.status == 1) {
      if (res.data.hasOwnProperty('error_code') && (res.data.error_code == 14013 || res.data.error_code == 14014 || res.data.error_code == 14015 || res.data.error_code == 14016 || res.data.error_code == 14019 || res.data.error_code == 14029 || res.data.error_code == 12000 || res.data.error_code == 12016 || res.data.error_code == 12022 || res.data.error_code == 11035 || res.data.error_code == 11034 || res.data.error_code == 18014)) {
        success = false;
      } else {
        success = true;
      }
    }
  } else {
    if (res.hasOwnProperty("message")) {
      message = res.message
    } else {
      message = res
    }
  }

  if (success) {
    toast.success(message, {
      position: toast.POSITION.BOTTOM_LEFT,
    })
  } else if (res.data.hasOwnProperty('error_code') && (res.data.error_code != 14013 && res.data.error_code != 14014 && res.data.error_code != 14015 && res.data.error_code != 14016 && res.data.error_code != 14019 && res.data.error_code != 14029 && res.data.error_code != 12000 && res.data.error_code != 12016 && res.data.error_code != 12022 && res.data.error_code != 11035 && res.data.error_code != 11034 && res.data.error_code != 18014)) {
    toast.error(message, {
      position: toast.POSITION.BOTTOM_LEFT,
    })
  }
  handleResponse(res, dispatch, handler)
}

export const upgradeInventoryLicense = (payload, k4Id) => (dispatch) => {
  dispatch({ type: SET_UPGRADE_INVENTORY_LICENSE_LOADING, payload: true });
  const syncPayload = {
    site_ids: [k4Id], device_ids: [payload?.did], request_type: CHANGE_LICENSE_SYNC
  }
  api
    .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/updateLicense/v1`, payload, syncPayload, dispatch)
    .then((res) => handleToastMessage(res, dispatch, GET_UPGRADE_INVENTORY_LICENSE))
    .catch((err) => {
      dispatch({ type: SET_UPGRADE_INVENTORY_LICENSE_LOADING, payload: false });
      handleError(err, dispatch)
    });
};

export const getTrafficPolicyDataV3 = (payload) => (dispatch) => {
  dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: true });


  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) => {
      dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: false })
      return handleResponse(res, dispatch, GET_TRAFFIC_POLICY_LIST_V3)
    })
    .catch((err) => {
      dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: false });
      handleError(err, dispatch)
    });
}

export const getTrafficPolicyDataV4 = (payload) => (dispatch) => {
  dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: true });
  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) => {
      dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: false })
      return handleResponse(res, dispatch, GET_TRAFFIC_POLICY_LIST_V4)
    })
    .catch((err) => {
      dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: false })
      handleError(err, dispatch)
    });
}

export const getTrafficPolicyDataV5 = (payload) => (dispatch) => {
  dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: true });
  api
    .postRequestOut(`/store/pg/query`, payload)
    .then((res) => {
      dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: false })
      return handleResponse(res, dispatch, GET_TRAFFIC_POLICY_LIST_V5)
    })
    .catch((err) => {
      dispatch({ type: GET_TRAFFIC_POLICY_LISTING_LOADING, payload: false })
      handleError(err, dispatch)
    });
}

export const getDeviceTransferData = (deviceId, siteId, oldSiteId) => (dispatch) => {
  dispatch({ type: GET_DEVICE_TRANSFER_LOADING, payload: true });
  const payload: any = {
    did: deviceId,
    new_site: siteId
  }
  const syncPayload = {
    site_ids: [oldSiteId, siteId], device_ids: [deviceId], request_type: DEVICE_MOVEMENT_SYNC
  }
  api
      .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/deviceMvmt/v1`, payload, syncPayload, dispatch)
      .then((res) => showToastMessage(res, dispatch, GET_DEVICE_TRANSFER))
      .catch((err) => {
        dispatch({ type: GET_DEVICE_TRANSFER_LOADING, payload: false });
        handleError(err, dispatch)
      });
};

export const getCancelDeRegisterData = (deviceId, reason) => (dispatch) => {
  dispatch({ type: SET_CANCEL_DE_REGISTER, payload: true });
  const payload:any = {
    deviceId: deviceId,
    reason: reason
  }
  const syncPayload = {
    site_ids: [], device_ids: [deviceId], request_type: CANCEL_DE_REGISTER_SYNC
  }
  api
    .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/cancelDIDDeregReq/v1`, payload, syncPayload, dispatch)
    .then((res) => handleToastMessage(res, dispatch, GET_CANCEL_DE_REGISTER))
    .catch((err) => {
      dispatch({ type: SET_CANCEL_DE_REGISTER, payload: false });
      handleError(err, dispatch)
    });
};

export const cancelScheduledUpgrade = (siteId, deviceId, edgeTransactionId) => async(dispatch) => {
  dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: true });
  const URL = '/v1/sites/software/upgrade/scheduled/cancel';
  const payload = {
    site_id: siteId,
    device_id: deviceId,
    edge_transaction_id: edgeTransactionId
  };
  try {
    const res = await api.siteController.post(URL, payload);
    if (res && res.success === true) {
      toast.success(res.result, { position: toast.POSITION.BOTTOM_LEFT });
    } else {
      toast.error(res.result || 'Failed to cancel scheduled upgrade', { position: toast.POSITION.BOTTOM_LEFT });
    }
    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false });
    return res;
  } catch (error) {
    dispatch({ type: SET_INVENTORY_LISTING_LOADING, payload: false });
    toast.error('API error: Failed to cancel scheduled upgrade', { position: toast.POSITION.BOTTOM_LEFT });
    return null;
  }
}

export const getPauseLicenseData = (payload) => (dispatch) => {
  dispatch({ type: SET_PAUSE_LICENSE, payload: true });
  const syncPayload = {
    site_ids: [payload.k4Id], device_ids: [payload.deviceId], request_type: PAUSE_LICENSE_SYNC
  }
  api
    .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/pauseLicense`, payload, syncPayload, dispatch)
    .then((res) => handleToastMessage(res, dispatch, GET_PAUSE_LICENSE))
    .catch((err) => {
      dispatch({ type: SET_PAUSE_LICENSE, payload: false });
      handleError(err, dispatch)
    });
};

export const getResumeLicenseData = (deviceId, resumeDate, validated=false, k4Id) => (dispatch) => {
  dispatch({ type: SET_RESUME_LICENSE, payload: true });
  const payload: any = {
    did: deviceId,
    resume_on: resumeDate,
    validated: validated
  }
  const syncPayload = {
    site_ids: [k4Id], device_ids: [deviceId], request_type: RESUME_LICENSE_SYNC
  }
  api
    .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/resumeDeviceLicense/v1`, payload, syncPayload, dispatch)
    .then((res) => handleToastMessage(res, dispatch, GET_RESUME_LICENSE))
    .catch((err) => {
      dispatch({ type: SET_RESUME_LICENSE, payload: false });
      handleError(err, dispatch)
    });
};

export const getWHProdGPDeviceListData = (dpId, device_id) => (dispatch) => {
  dispatch({ type: SET_WH_ProdGP_DEVICE_LIST, payload: true });
  api
  .getRequestForExternalApi(`${KAPTUREV2_URL_INV}inventoryConfig/getToDidsListV2?dp_id=${dpId}&device_id=${device_id}`)
    .then((res) => handleResponse(res, dispatch, GET_WH_ProdGP_DEVICE_LIST))
    .catch((err) => {
      dispatch({ type: SET_WH_ProdGP_DEVICE_LIST, payload: false });
      handleError(err, dispatch)
    });
};

export const getTransferLicenseData = (fromDevice, toDevice, validated, k4Id) => (dispatch) => {
  dispatch({ type: SET_TRANSFER_LICENSE_LOADING, payload: true });
  const payload: any = {
    fromDID: fromDevice,
    toDID: toDevice,
    isValidated: validated
  }
  const syncPayload = {
    site_ids: [k4Id], device_ids: [fromDevice, toDevice], request_type: TRANSFER_LICENSE_SYNC
  }
  api
    .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/didLicenseTransfer`, payload, syncPayload, dispatch)
    .then((res) => handleToastMessage(res, dispatch, GET_TRANSFER_LICENSE))
    .catch((err) => {
      dispatch({ type: SET_TRANSFER_LICENSE_LOADING, payload: false });
      handleError(err, dispatch)
    });
}

export const getCancelPauseLicenseData = (deviceId, k4Id) => (dispatch) => {
  dispatch({ type: SET_CANCEL_PAUSE_LICENSE_LOADING, payload: true });
  const syncPayload = {
    site_ids: [k4Id], device_ids: [deviceId], request_type: CANCEL_PAUSE_LICENSE_SYNC
  }
  const payload: any = {
    deviceId: deviceId
  }
  api
    .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/cancelPauseLicense/v1`, payload, syncPayload, dispatch)
    .then((res) => handleToastMessage(res, dispatch, GET_CANCEL_PAUSE_LICENSE))
    .catch((err) => {
      dispatch({ type: SET_CANCEL_PAUSE_LICENSE_LOADING, payload: false });
      handleError(err, dispatch)
  });
}

export const attachDeviceToSiteData = (payload) => (dispatch) => {
  const syncPayload = {
    site_ids: [payload?.k4Id], device_ids: [payload?.did], request_type: ATTACH_DEVICE_TO_SITE_SYNC
  }
  dispatch({ type: SET_ATTACH_DEVICE_TO_SITE_LOADING, payload: true });
  api
    .postRequestForExternalApiWithSync(`${KAPTUREV2_URL_INV}inventoryConfig/attachDidToSite`, payload, syncPayload, dispatch)
    .then((res) => showToastMessage(res, dispatch, GET_ATTACH_DEVICE_TO_SITE))
    .catch((err) => {
      dispatch({ type: SET_ATTACH_DEVICE_TO_SITE_LOADING, payload: false });
      handleError(err, dispatch)
    });
};

export const createShareConfigData = (configId, payload) => (dispatch) => {
  dispatch({ type: SET_CREATE_SHARE_CONFIG_LOADING, payload: true });
  let URL = `${CONFIG_BASE_URL}/${configId}/share`;
  api.siteController.post(URL, payload)
      .then((res) => {
          dispatch({ type: CREATE_SHARE_CONFIG, payload: res });
      })
      .catch((err) => {
          dispatch({ type: SET_CREATE_SHARE_CONFIG_LOADING, payload: false })
      });
}

export const getSharedConfigPerConfigData = (configId, dpIds) => (dispatch) => {
  dispatch({ type: SET_SHARED_CONFIG_PER_CONFIG_LOADING, payload: true });
  const apiUrl =  `/store/pg/query`;
  const payload: any = {
    query: "GET_CONFIG_SHARED_WITH_OUS",
    named: true,
    format: "JSON",
    parameters: {
      config_id: configId,
      ou_ids: dpIds?.map(id => `'${id}'`)?.join(',')
    }
  }
  postRequest(apiUrl, payload)
      .then((res) => {
          dispatch({ type: GET_SHARED_CONFIG_PER_CONFIG, payload: res?.data });
      })
      .catch((err) => {
          dispatch({ type: SET_SHARED_CONFIG_PER_CONFIG_LOADING, payload: false })
      });
}

export const updateSharedConfigData = (configId, payload) => (dispatch) => {
  dispatch({ type: SET_UPDATE_SHARED_CONFIG_LOADING, payload: true });
  let URL = `${CONFIG_BASE_URL}/${configId}/share`;
  api.siteController.put(URL, payload)
      .then((res) => {
          dispatch({ type: UPDATE_SHARED_CONFIG, payload: res });
      })
      .catch((err) => {
          dispatch({ type: SET_UPDATE_SHARED_CONFIG_LOADING, payload: false })
      });
}

export const deleteSharedConfigData = (configId, payload) => (dispatch) => {
  dispatch({ type: SET_DELETE_SHARED_CONFIG_LOADING, payload: true });
  let URL = `${CONFIG_BASE_URL}/${configId}/share`;
  api.siteController.delete(URL, payload)
      .then((res) => {
          dispatch({ type: DELETE_SHARED_CONFIG, payload: res });
      })
      .catch((err) => {
          dispatch({ type: SET_DELETE_SHARED_CONFIG_LOADING, payload: false })
      });
}